import React from 'react';
import { withPageReadyAsync } from '@bingads-webui-react/with-page-ready';

const DelayedContentFooter = withPageReadyAsync(() =>
  import(/* webpackMode: 'eager' */'./index')
    .then(ContentFooter => ContentFooter), null);

export function withFooter(Component) {
  return props => (
    <React.Fragment>
      <div className="app-content-body" style={{ flex: '1 0 auto', marginBottom: 'auto' }}>
        <Component {...props} />
      </div>
      <DelayedContentFooter />
    </React.Fragment>
  );
}
